import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'glass' | 'danger' | 'outline';
  fullWidth?: boolean;
  isLoading?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  fullWidth = false,
  isLoading = false,
  size = 'md',
  className = '',
  ...props 
}) => {
  // Tailwind-first variants for polished, consistent, non-lazy buttons
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-[0.01em] transition-all active:scale-[0.98] disabled:opacity-45 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-white text-fit-ink hover:bg-[#e6e6e6]',
    secondary: 'bg-white text-fit-ink hover:bg-[#e6e6e6]',
    glass: 'bg-white/5 border border-fit-line text-fit-text hover:bg-white/10 hover:border-fit-line-strong',
    outline: 'bg-transparent border border-fit-line-strong text-fit-text hover:border-white hover:bg-white/5',
    danger: 'bg-fit-red text-white hover:brightness-95',
  };

  const sizes = {
    sm: 'px-4 py-1.5 text-xs',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-7 py-3 text-base',
  };

  const classes = [
    base,
    variants[variant],
    sizes[size],
    fullWidth ? 'w-full' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      {...props}
      disabled={isLoading || props.disabled}
      className={classes}
    >
      {isLoading ? '...' : children}
    </button>
  );
};

export default Button;
